module.exports = __webpack_public_path__ + "5088a9890f9528767a48be4c9a1e0421.png";